import { encryptObject } from "@/helpers/noncehelper";
import {
  addRecipePersonalNote,
  getRecipePersonalNote,
  updateRecipePersonalNote,
  deleteRecipePersonalNote,
} from "@/services/recipes";
import { fetchSafeJson } from "@/utils/apiResponse";
import { createAsyncThunk } from "@reduxjs/toolkit";

export const createRecipePersonalNoteAction = createAsyncThunk(
  "/recipes/personal-note",
  async (payload: any) => {
    try {
      const res = await addRecipePersonalNote(encryptObject(payload));
      return res;
    } catch (error) {
      console.log(error);
    }
  }
);

export const updateRecipePersonalNoteAction = createAsyncThunk(
  "/personal-note/update",
  async (payload: any) => {
    try {
      const res = await updateRecipePersonalNote(encryptObject(payload));
      return res;
    } catch (error) {
      console.log(error);
    }
  }
);

export const getRecipePersonalNoteAction = createAsyncThunk(
  "/personal-note",
  async (payload: any) => {
    try {
      const res = await getRecipePersonalNote(
        encryptObject({
          recipe_id: payload.recipe_id,
          token: payload.token,
        })
      );
      const data: any = await fetchSafeJson(res);
      return data?.response;
    } catch (error) {
      console.log(error);
    }
  }
);

export const deleteRecipePersonalNoteAction = createAsyncThunk(
  "/personal-note/delete",
  async (payload: any) => {
    try {
      const { id, token } = payload;

      const response = await deleteRecipePersonalNote(
        encryptObject({
          id,
          token,
        })
      );
      return response;
    } catch (error: any) {
      console.error("Error deleting recipe lists:", error);
    }
  }
);